import React, { useState } from 'react';
import { Card, CardBody, Col, Row, Input, Label, Modal, Button, Form, FormFeedback, FormGroup } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FormikProvider, ErrorMessage } from "formik";
import '../../../global/GlobalCSS.css';
import "flatpickr/dist/themes/material_blue.css";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import { Fuel, FuelType } from './VesselMaster.model';
import apiGlobal from '../../../global/api.global';
import { apiMedia } from '../../../global/api.global';
import AsyncSelect from 'react-select/async';
import { useSelector } from 'react-redux';
import { loadPortOptions, load_Countries, load_Fuel_Types, load_Hull_Types, load_Vessel_Owners, load_Vessel_Sub_Types, load_Vessel_Types } from 'VesselMaster/vesselMaster.hooks';
import { successToast } from '../../../Components/Toasts';
import { customStyle, errorStyle } from '../../../shared/CommonCSS';
import { formatBytes } from 'GenericForms/Helper';

const VesselGeneralInfo = () => {
    const [selectedFiles, setselectedFiles] = useState<any>([]);
    const [modal_backdrop, setmodal_backdrop] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false)
    const [fuelTypes, setFuelTypes] = useState<Array<FuelType>>([]);
    const [fuels] = useState<Array<Fuel>>([]);
    const [filteredFuels] = useState<Array<any>>([])
    const { Vessels, VesselID, } = useSelector(
        (state: any) => state.Reporting
    );
    const record = Vessels.find((rec: any) => rec.id === VesselID)
    const inital = {
        vessel_name: "",
        vessel_short_name: "",
        IMO_number: "",
        vessel_type_name: "",
        vessel_sub_type_name: "",
        country_name: "",
        port_of_registry: "",
        vessel_previous_name: "",
        date_of_change: "",
        call_sign: "",
        vessel_owner: "",
        date_of_built: "",
        official_number: "",
        hull_type_name: "",
        hull_number: "",
        dead_weight: "",
        //fuel_type_id: "",
        fuel_name: filteredFuels,
        vessel_description: "",
        image: '',
        fuel_type_name: '',
    }
    const [data, setData] = useState(inital)

    const load_Fuels = async () => {
        fuels.length = 0;
        return apiGlobal(`/fuel_master/`)
            .then((response) => {
                fuelTypes.map((fuelType: any) => (
                    response.data.filter((fuel: any) => fuel.fuel_type_name === fuelType).map((item: any, index: number) => {
                        return (
                            fuels.splice(index, 0, item)
                        )
                    })
                ))
                console.log(fuels);
                return fuels;
            })
    }

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    }

    function handleAcceptedFiles(files: any) {
        files.map((file: any) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            })
        );
        setselectedFiles(files);
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }


    // Form validation 
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: inital,
        validationSchema: Yup.object().shape({
            // vessel_short_name: Yup.string().matches(
            //     /^[A-Za-z]{2,25}$/, "Please enter upto 25 alphabets only"
            // ).required("Please enter the vessel short name"),
            // port_of_registry: Yup.string().required("Please enter vessel's port of registry"),
            // call_sign: Yup.string().matches(
            //     /^[A-Za-z0-9][a-zA-Z0-9-_.]{1,7}$/, "Please enter upto 7 alphabets/digits only"
            // ).required("Please enter vessel's call sign"),
            // official_number: Yup.string().matches(
            //     /^[0-9]{1,10}$/, "Please enter upto 10 digits only"
            // ).required("Please enter vessel's official number"),
            // vessel_owner: Yup.string().required("Please enter company's name"),
            // vessel_type_name: Yup.string().required("Please enter vessel type"),
            // vessel_sub_type_name: Yup.string().required("Please enter vessel sub type"),
            // country_name: Yup.string().required("Please enter country name"),
            // hull_type_name: Yup.string().required("Please enter hull type"),
            // hull_number: Yup.string().matches(
            //     /^[A-Za-z0-9][a-zA-Z0-9-_.]{11}$/, "Please enter 12 aplphabets/digits only"
            // ).required("Please enter hull number"),
            // fuel_type_name: Yup.string().required("Please enter fuel type name"),
            // fuel_name: Yup.array().required("Please enter fuel name"),
            // dead_weight: Yup.string().matches(
            //     /^[0-9]+$/, "Please enter digits only"
            // ).required("Please enter the deadweight"),
            // vessel_description: Yup.string().matches(
            //     /^[A-Za-z][a-zA-Z0-9-_.]{1,200}$/, "Please enter upto 200 alphabets/digis only"
            // ),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            for (const key in datas) {
                formData.append(key, datas[key]);
            }
            formData.set('image', selectedFiles[0]);
            formData.set('vessel_name', record.id);
            apiMedia.post(`/vessel_general_information/`, formData).then(res => {
                successToast("Data saved successfully!");
            })
                .catch(err => {
                    console.log(err);
                });
        }
    });

    const datas: any = {
        vessel_name: record.vessel_name,
        vessel_short_name: data.vessel_short_name,
        IMO_number: record.IMO_number,
        vessel_type_name: record.vessel_type,
        vessel_sub_type_name: data.vessel_sub_type_name,
        country_name: data.country_name,
        port_of_registry: data.port_of_registry,
        vessel_previous_name: data.vessel_previous_name,
        date_of_change: data.date_of_change,
        call_sign: data.call_sign,
        vessel_owner: data.vessel_owner,
        date_of_built: data.date_of_built,
        official_number: data.official_number,
        hull_type_name: data.hull_type_name,
        hull_number: data.hull_number,
        dead_weight: data.dead_weight,
        fuel_name: data.fuel_name,
        vessel_description: data.vessel_description,
        image: data.image,
    };

    function handle(e: any) {
        const newdata: any = { ...data }
        newdata[e.target.name] = e.target.value
        setData(newdata)
    }

    const handleChanges = (event: any, validation: any) => {
        validation.handleChange(event);
        handle(event);
    }

    function handleSelect(e: any, name: any) {
        let newdata: any = { ...data }
        newdata[name] = e.id;
        setData(newdata);
        if (name === 'vessel_sub_type_name') {
            setErrorMsg(true);
        }
    }

    function handle_Fuel_Type(e: any, actionMeta: any) {
        if (actionMeta.action === 'remove-value') {
            fuelTypes.splice(fuelTypes.length - 1, 1)
            load_Fuels()
        } else if (actionMeta.action === 'select-option') {
            fuelTypes.splice(fuelTypes.length, 0, (e[fuelTypes.length].id))
            let prevValues = [...fuelTypes]
            setFuelTypes(prevValues)
            load_Fuels()
        }
    }

    function handle_Fuel(e: any, actionMeta: any) {
        if (actionMeta.action === 'remove-value') {
            filteredFuels.splice(filteredFuels.length - 1, 1)
        } else if (actionMeta.action === 'select-option') {
            filteredFuels.splice(filteredFuels.length, 0, e[filteredFuels.length].id)
        }
    }

    return (
        <React.Fragment>
            <FormikProvider value={validation}>
                <Form className="needs-validation" autoComplete="off"
                    onSubmit={validation.handleSubmit}
                >
                    <Card>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="vessel_name"
                                            name="vessel_name"
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={record.vessel_name}
                                            invalid={
                                                validation.touched.vessel_name && validation.errors.vessel_name ? true : false
                                            }
                                        />
                                        {validation.touched.vessel_name && validation.errors.vessel_name ? (
                                            <FormFeedback type="invalid">{validation.errors.vessel_name}</FormFeedback>
                                        ) : null}
                                        <Label for="vessel_name">Vessel name</Label>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <Input
                                            type="text"
                                            className="form-control text-uppercase"
                                            id="vessel_short_name"
                                            name="vessel_short_name"
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={validation.values.vessel_short_name || data.vessel_short_name}
                                            invalid={
                                                validation.touched.vessel_short_name && validation.errors.vessel_short_name ? true : false
                                            }
                                            autoFocus
                                        />
                                        {validation.touched.vessel_short_name && validation.errors.vessel_short_name ? (
                                            <FormFeedback type="invalid">{validation.errors.vessel_short_name}</FormFeedback>
                                        ) : null}
                                        <Label for="vessel_name">Vessel short name</Label>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <div className="form-floating mb-3">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="IMO_number"
                                            name='IMO_number'
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={record.IMO_number}
                                            invalid={
                                                validation.touched.IMO_number && validation.errors.IMO_number ? true : false
                                            }
                                        />
                                        {validation.touched.IMO_number && validation.errors.IMO_number ? (
                                            <FormFeedback type="invalid">{validation.errors.IMO_number}</FormFeedback>
                                        ) : null}
                                        <Label for="IMO_number">IMO number</Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select vessel type</Label><br></br>
                                            <AsyncSelect
                                                name="vessel_type_name"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={load_Vessel_Types}
                                                getOptionLabel={(e: any) => e.vessel_type_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={(e: any) => handleSelect(e, 'vessel_type_name')}
                                                className='select-height select-border'
                                                menuPortalTarget={document.body}
                                                styles={validation.errors.vessel_type_name == null ? customStyle : errorStyle}
                                                defaultInputValue={record.vessel_type}
                                            />
                                            {validation.errors.vessel_type_name ?
                                                <ErrorMessage name='vessel_type_name' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select vessel sub type</Label><br></br>
                                            <AsyncSelect
                                                name="vessel_sub_type_name"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={load_Vessel_Sub_Types}
                                                getOptionLabel={(e: any) => e.vessel_sub_type_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={(e: any) => handleSelect(e, 'vessel_sub_type_name')}
                                                styles={validation.errors.vessel_type_name || errorMsg === true ? errorStyle : customStyle}
                                                menuPortalTarget={document.body}
                                            />
                                            {validation.errors.vessel_sub_type_name || errorMsg === false ?
                                                <ErrorMessage name='vessel_sub_type_name' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select flag administrator</Label><br></br>
                                            <AsyncSelect
                                                name="country_name"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={load_Countries}
                                                getOptionLabel={(e: any) => e.country_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={(e: any) => handleSelect(e, 'country_name')}
                                                styles={validation.errors.country_name == null ? customStyle : errorStyle}
                                                menuPortalTarget={document.body}
                                            />
                                            {validation.errors.country_name ?
                                                <ErrorMessage name='country_name' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select port of registry</Label><br></br>
                                            <AsyncSelect
                                                name="port_of_registry"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={loadPortOptions}
                                                getOptionLabel={(e: any) => e.port_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={(e: any) => handleSelect(e, 'port_of_registry')}
                                                styles={validation.errors.port_of_registry == null ? customStyle : errorStyle}
                                                menuPortalTarget={document.body}
                                            />
                                            {validation.errors.port_of_registry ?
                                                <ErrorMessage name='port_of_registry' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="form-floating mb-3">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="call_sign"
                                            name="call_sign"
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={validation.values.call_sign || data.call_sign}
                                            invalid={
                                                validation.touched.call_sign && validation.errors.call_sign ? true : false
                                            }
                                        />
                                        {validation.touched.call_sign && validation.errors.call_sign ? (
                                            <FormFeedback type="invalid">{validation.errors.call_sign}</FormFeedback>
                                        ) : null}
                                        <Label for="call_sign" className='asteric'>Call sign</Label>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select vessel owner</Label><br></br>
                                            <AsyncSelect
                                                name="vessel_owner"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={load_Vessel_Owners}
                                                getOptionLabel={(e: any) => e.company_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={(e: any) => handleSelect(e, 'vessel_owner')}
                                                styles={validation.errors.vessel_owner == null ? customStyle : errorStyle}
                                                menuPortalTarget={document.body}
                                            />
                                            {validation.errors.vessel_owner ?
                                                <ErrorMessage name='vessel_owner' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <FormGroup className="mb-3">
                                        <Label className='mb-0'>Date of built</Label><br />
                                        <input
                                            type='date'
                                            name='date_of_built'
                                            value={data.date_of_built}
                                            onChange={handle}
                                            className='datepicker text-uppercase'
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="form-floating mb-3">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="official_number"
                                            name='official_number'
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={validation.values.official_number || data.official_number}
                                            invalid={
                                                validation.touched.official_number && validation.errors.official_number ? true : false
                                            }
                                        />
                                        {validation.touched.official_number && validation.errors.official_number ? (
                                            <FormFeedback type="invalid">{validation.errors.official_number}</FormFeedback>
                                        ) : null}
                                        <Label for="official_number" className='asteric'>Official number</Label>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select hull type</Label><br></br>
                                            <AsyncSelect
                                                name="hull_type_name"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={load_Hull_Types}
                                                getOptionLabel={(e: any) => e.hull_type_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={(e: any) => handleSelect(e, 'hull_type_name')}
                                                styles={validation.errors.hull_type_name == null ? customStyle : errorStyle}
                                                menuPortalTarget={document.body}
                                            />
                                            {validation.errors.hull_type_name ?
                                                <ErrorMessage name='hull_type_name' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <div className="form-floating mb-3">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="hull_number"
                                            name='hull_number'
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={validation.values.hull_number || data.hull_number}
                                            invalid={
                                                validation.touched.hull_number && validation.errors.hull_number ? true : false
                                            }
                                        />
                                        {validation.touched.hull_number && validation.errors.hull_number ? (
                                            <FormFeedback type="invalid">{validation.errors.hull_number}</FormFeedback>
                                        ) : null}
                                        <Label for="hull_number" className='asteric'>Hull number</Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select fuel type</Label><br></br>
                                            <AsyncSelect
                                                name="fuel_type_name"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={load_Fuel_Types}
                                                getOptionLabel={(e: any) => e.fuel_type_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={handle_Fuel_Type}
                                                isMulti
                                                styles={validation.errors.fuel_type_name == null ? customStyle : errorStyle}
                                                menuPortalTarget={document.body}
                                            />
                                            {validation.errors.fuel_type_name ?
                                                <ErrorMessage name='fuel_type_name' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <FormGroup className="form-floating mb-3">
                                        <div className="mb-3">
                                            <Label className='asteric'>Select fuel</Label><br></br>
                                            <AsyncSelect
                                                name="fuel_name"
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={load_Fuels}
                                                getOptionLabel={(e: any) => e.fuel_name}
                                                getOptionValue={(e: any) => e.id}
                                                onChange={handle_Fuel}
                                                isMulti
                                                styles={validation.errors.fuel_name == null ? customStyle : errorStyle}
                                                menuPortalTarget={document.body}
                                            />
                                            {validation.errors.fuel_name ?
                                                <ErrorMessage name='fuel_name' component="span" className="error" /> : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col lg={4}>
                                    <div className="form-floating mb-3 input-group">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="dead_weight"
                                            name='dead_weight'
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={validation.values.dead_weight || data.dead_weight}
                                            invalid={
                                                validation.touched.dead_weight && validation.errors.dead_weight ? true : false
                                            }
                                        />
                                        <div className="input-group-text">mt</div>
                                        {validation.touched.dead_weight && validation.errors.dead_weight ? (
                                            <FormFeedback type="invalid">{validation.errors.dead_weight}</FormFeedback>
                                        ) : null}
                                        <Label for="dead_weight" className='asteric'>Deadweight</Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="form-floating mb-3">
                                        <Input
                                            type="textarea"
                                            className="form-control"
                                            id="textarea"
                                            name='vessel_description'
                                            placeholder='example'
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={validation.values.vessel_description || data.vessel_description}
                                            invalid={
                                                validation.touched.vessel_description && validation.errors.vessel_description ? true : false
                                            }
                                        />
                                        {validation.touched.vessel_description && validation.errors.vessel_description ? (
                                            <FormFeedback type="invalid">{validation.errors.vessel_description}</FormFeedback>
                                        ) : null}
                                        <Label for="vessel_description">Vessel description</Label>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <Label
                                        onClick={() => {
                                            tog_backdrop();
                                        }}
                                        data-toggle="modal"
                                        className='mb-3 link_color_blue w_8'
                                        id='img_upload'
                                    >Upload vessel image</Label>
                                    <Modal
                                        isOpen={modal_backdrop}
                                        toggle={() => {
                                            tog_backdrop();
                                        }}
                                        backdrop={"static"}
                                        id="staticBackdrop"
                                    >
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="staticBackdropLabel">
                                                Upload image
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => {
                                                    setmodal_backdrop(false);
                                                }}
                                                aria-label="Close"
                                            ></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="form-floating mb-3">
                                                <Dropzone
                                                    onDrop={acceptedFiles => {
                                                        handleAcceptedFiles(acceptedFiles);

                                                    }}
                                                >
                                                    {({ getRootProps, getInputProps }) => (
                                                        <div className="dropzone">
                                                            <div
                                                                className="dz-message needsclick mt-2"
                                                                {...getRootProps()}
                                                            >
                                                                <input {...getInputProps()} />
                                                                <div className="mb-3">
                                                                    <i className="display-4 text-muted bx bx-cloud-upload" />
                                                                </div>
                                                                <h4>Click here to upload.</h4>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Dropzone>
                                                <div className="dropzone-previews mt-3" id="file-previews">
                                                    {selectedFiles.map((f: any, i: number) => {
                                                        return (
                                                            <Card
                                                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                                key={i + "-file"}
                                                            >
                                                                <div className="p-2">
                                                                    <Row className="align-items-center">
                                                                        <Col className="col-auto">
                                                                            <img
                                                                                data-dz-thumbnail=""
                                                                                height="80"
                                                                                className="avatar-sm rounded bg-light"
                                                                                alt={f.name}
                                                                                src={f.preview}
                                                                            />
                                                                        </Col>
                                                                        <Col>
                                                                            <Link
                                                                                to="#"
                                                                                className="text-muted font-weight-bold"
                                                                            >
                                                                                {f.name}
                                                                            </Link>
                                                                            <p className="mb-0">
                                                                                <strong>{f.formattedSize}</strong>
                                                                            </p>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Card>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </Modal>
                                </Col>
                            </Row>
                            <Row>
                                <div className="d-flex flex-wrap gap-5 grp_justify_right">
                                    <Button type="submit" color="primary" className='btn_size4_5_cstm'>Save</Button>
                                    <Button type="reset" color="danger" className='btn_size4_5_cstm'>Reset</Button>
                                </div>
                            </Row>
                        </CardBody>
                    </Card>
                </Form>
            </FormikProvider>
        </React.Fragment>

    )
}

export default VesselGeneralInfo;